import { ValidationRequestEntity, ValidationResponseEntity } from '@private/modules/cash-out-payment/core/entities';

export abstract class ValidationRepository {

  abstract validate(params: ValidationRequestEntity): Promise<ValidationResponseEntity>;

}
